import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/main_logo.png"
import short_logo from "../assets/fav_icon.png"
import user_icon from "../assets/user_img.jpg"
import toast from "react-hot-toast";
import axios from "axios";
import { changePasswordApi } from "../helper/api_helper";

const MasterLayout = ({ children }) => {
  const navigate = useNavigate()
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const [isChangePasswordOpen, setIsChangePassword] = useState(false)
  const [old_password, setOldPassword] = useState("")
  const [new_password, setNewPassword] = useState("")

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px";
        }
      });

      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`;
        }
      }
    };

    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            }
          }
        });
      });
    };

    openActiveDropdown();

    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };
  const handleLogOutClick = () => {
    localStorage.removeItem("token");

    window.location.href = "/";
  };
  let admin_data = JSON.parse(localStorage.getItem("adminData"));
  let username;
  let email;
  if (admin_data) {
    username = admin_data.username;
    email = admin_data.email;
  }

  const handleTrClick = () => {
    window.open("https://techrabbit.io/", "_blank");
  };
  const handleChangePassword = () => {

    setIsChangePassword(true)
  }
  const handleUpdatePassword = async () => {

    if (!email) {
      toast.error("Please enter email")
      return
    }
    if (!old_password) {
      toast.error("Please enter old password")
      return
    }
    if (!new_password) {
      toast.error("Please enter new password")
      return
    }
    const toastId = toast.loading("Changing your password...");

    try {

      let body = { email, oldPassword: old_password, newPassword: new_password };
      let response = await changePasswordApi(body)
      toast.success("Password Updated successfully", { id: toastId })
      setIsChangePassword(false)
      setOldPassword("")
      setNewPassword("")

    } catch (error) {
      toast.error(error || "Something Went Wrong", { id: toastId })


    }


  }


  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img src="/ship_logo.svg" alt="site logo" className="light-logo" />
            <img src="/small_logo.svg" alt="site logo" className="dark-logo" />
            <img src="/small_logo.svg" alt="site logo" className="logo-icon" />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul
            className="sidebar-menu"
            id="sidebar-menu"
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            <li>
              <NavLink
                to="/dashboard"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon
                  icon="solar:home-smile-angle-outline"
                  className="menu-icon"
                />
                <span>Dashboard</span>
              </NavLink>
            </li>

            <li className="dropdown">
              <Link to="#">
                <Icon icon="mdi:note-text-outline" className="menu-icon" />
                <span>Website Configuration</span>
              </Link>
              <ul className="sidebar-submenu">
                <li className="sidebar-menu-group-title">Blogs</li>
                <li>
                  <NavLink
                    to="/blog-category"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Blog Category
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/blog-tags"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Blog Tags
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/create-blog"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Create Blog
                  </NavLink>
                </li>
                <li
                  style={{
                    borderBottom: "1px dashed #bfbfbf",
                    marginBottom: "8px",
                    paddingBottom: "8px",
                  }}
                >
                  <NavLink
                    to="/blog"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Published Blogs
                  </NavLink>
                </li>

                <li className="sidebar-menu-group-title">Case Studies</li>
              

                <li
                 
                >
                  <NavLink
                    to="/create-case-study"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                    Create Case Study
                  </NavLink>
                </li>


                  <li  style={{
                    borderBottom: "1px dashed #bfbfbf",
                    marginBottom: "8px",
                    paddingBottom: "8px",
                  }}>
                  <NavLink
                    to="/case-study"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Published Case Studies
                  </NavLink>
                </li>

                <li className="sidebar-menu-group-title">
                  Shipping Calculator
                </li>
                <li>
                  <NavLink
                    to="/configuration"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                    Configuration
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/discount"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Discount
                  </NavLink>
                </li>

                {/* <li
                  style={{
                    borderBottom: "1px dashed #bfbfbf",
                    marginBottom: "8px",
                    paddingBottom: "8px",
                  }}
                >
                  <NavLink
                    to="/create-case-study"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    Create Case Study
                  </NavLink>
                </li>

                <li className="sidebar-menu-group-title">Contact Inquiry</li>

                <li>
                  <NavLink
                    to="/conatct-inquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Contact Inquiry
                  </NavLink>
                </li> */}
              </ul>
            </li>
            <li className="dropdown">
              <Link to="#">
                <Icon icon="mdi:note-text-outline" className="menu-icon" />
                <span>App Configuration</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/slider-management"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                    App Slider
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink
                    to="/shipment-enquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    <span>Package Enquiry</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/we-procure"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    WeProcure
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/we-qa"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    WeQA
                  </NavLink>
                </li> */}
                <li>
                  <NavLink
                    to="/marketing-notifications"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    <span>Marketing Notification</span>
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* <li className="dropdown">
              <Link to="#">
                <Icon icon="mdi:note-text-outline" className="menu-icon" />
                <span>Shipping Calculator</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/configuration"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Configuration
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/discount"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    <span>Discount</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/shipping-calculator-enquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    <span>Inquiries</span>
                  </NavLink>
                </li>
              </ul>
            </li> */}

            <li className="dropdown">
              <Link to="#">
                <Icon icon="mdi:note-text-outline" className="menu-icon" />
                <span>Inquiries Management</span>
              </Link>
              <ul className="sidebar-submenu">
                <li>
                  <NavLink
                    to="/shipment-enquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                    Package (App)
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/we-procure"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    WeProcure (App)
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/we-qa"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                    WeQA (App)
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/conatct-inquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                    Contact (Web)
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/shipping-calculator-enquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                    Shipment Cal (Web)
                  </NavLink>
                </li>

                {/* <li>
                  <NavLink
                    to="/discount"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                    Discoun
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/shipping-calculator-enquiry"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                    <span>Inquiries</span>
                  </NavLink>
                </li> */}
              </ul>
            </li>

            <li>
              <NavLink
                to="/support"
                className={(navData) => (navData.isActive ? "active-page" : "")}
              >
                <Icon icon="tabler:headset" className="menu-icon" />
                <span>Support</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={user_icon}
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {username}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          Admin
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <li>
                      <button
                        onClick={handleChangePassword}
                        className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3 w-full text-left"
                      >
                        <Icon icon="mdi:lock-reset" className="icon text-xl" />
                        Change Password
                      </button>
                    </li>
                    <ul className="to-top-list">
                      <li>
                        <button
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={handleLogOutClick}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="dashboard-main-body">{children}</div>

        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">
                © 2025{" "}
                <a href="" target="blank">
                  Shipora.
                </a>{" "}
                All Rights Reserved.
              </p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by{" "}
                <span
                  className="text-primary-600"
                  style={{ cursor: "pointer" }}
                  onClick={handleTrClick}
                >
                  Tech Rabbit
                </span>
              </p>
            </div>
          </div>
        </footer>
      </main>

      {isChangePasswordOpen && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div
              className="modal-dialog modal-md modal-dialog-centered"
              style={{ zIndex: 11122 }}
            >
              <div className="modal-content radius-16 bg-base">
                <div className="modal-header py-16 px-24 border-bottom">
                  <h1 className="modal-title fs-5">Change Password</h1>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsChangePassword(false)}
                  />
                </div>

                <div className="modal-body p-24">
                  <form className="row g-3">
                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        Old Password
                      </label>
                      <input
                        type="text"
                        name="username"
                        className="form-control"
                        placeholder="Please enter old password"
                        value={old_password}
                        onChange={(e) => setOldPassword(e.target.value)}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label fw-semibold">
                        New Password
                      </label>
                      <div className="position-relative">
                        <input
                          name="password"
                          placeholder="Please enter new password"
                          className="form-control pe-40"
                          value={new_password}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <span
                          className="position-absolute top-50 end-0 translate-middle-y me-12 cursor-pointer"
                          style={{ zIndex: 2, display: "flex" }}
                        >
                          <Icon className="text-muted" />
                        </span>
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                      <button
                        type="button"
                        className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-24 py-10 radius-8"
                        onClick={() => setIsChangePassword(false)}
                      >
                        Cancel
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary border border-primary-600 text-md px-32 py-10 radius-8 d-flex align-items-center gap-2"
                        onClick={handleUpdatePassword}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1040 }}
            />
          </div>
        </>
      )}
    </section>
  );
};

export default MasterLayout;
